// removed by extract-text-webpack-plugin
module.exports = {"FooterNavigation":"src-components-Footer----FooterNavigation-module---FooterNavigation---1EZJW","agbLink":"src-components-Footer----FooterNavigation-module---agbLink---1RI8M"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/FooterNavigation.module.css
// module id = 375
// module chunks = 114276838955818